import { Component } from '@theme/component';
const savedBaubleWording = new Map();

class CraftmagBaubleFields extends Component {
  validateForVariant(variantId) {
    const form = this.closest('form');
    if (!form || variantId !== this.dataset.variantId) return false;
    for (const field of this.querySelectorAll('input[type="text"], textarea')) {
      field.setCustomValidity(field.required && !field.value.trim() ? field.labels[0].textContent.trim() : '');
    }
    return form.reportValidity();
  }

  connectedCallback() {
    super.connectedCallback();
    this.bindFields();
  }

  updatedCallback() {
    super.updatedCallback();
    this.bindFields();
  }

  bindFields() {
    this.abortController?.abort();
    this.abortController = new AbortController();
    const { signal } = this.abortController;
    const form = this.closest('form');
    if (!form) return;
    const key = this.dataset.productId + ':' + this.dataset.mode;
    const restore = savedBaubleWording.get(key) || {};
    for (const field of this.querySelectorAll('input[type="text"], textarea')) {
      if (restore[field.name] !== undefined) field.value = restore[field.name];
      field.addEventListener('input', () => {
        field.setCustomValidity('');
        const values = {};
        for (const input of this.querySelectorAll('input[type="text"], textarea')) values[input.name] = input.value;
        savedBaubleWording.set(key, values);
      }, { signal });
    }
    form.addEventListener('submit', event => {
      const currentVariant = form.querySelector('input[name="id"]')?.value;
      if (!this.validateForVariant(currentVariant)) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    }, { capture: true, signal });
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.abortController?.abort();
  }
}

if (!customElements.get('craftmag-bauble-fields')) customElements.define('craftmag-bauble-fields', CraftmagBaubleFields);
